import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { DropdownMenu, DropdownToggle } from '../../atoms';

export interface DropdownItem {
  eventKey: string;
  label: string;
}

interface CustomDropdownProps {
  items: DropdownItem[];
  initialTitle: string;
  onSelectOption?: (option: DropdownItem) => void;
  disabled?: boolean;
  searchable?: boolean;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  items,
  initialTitle,
  onSelectOption,
  disabled,
  searchable = true,
}) => {
  const [selectedItem, setSelectedItem] = useState(initialTitle);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSelect = (eventKey: string) => {
    const selected = items.find((item) => item.eventKey === eventKey);
    if (selected && onSelectOption) {
      setSelectedItem(selected.label);
      onSelectOption(selected);
    }
  };

  const filteredItems = items.filter((item) =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    setSelectedItem(initialTitle);
    const selected = items.find((item) => item.label === initialTitle);
    if (selected && onSelectOption) {
      onSelectOption(selected);
    }
  }, [initialTitle]);

  return (
    <Dropdown onSelect={(eventKey: any) => handleSelect(eventKey)}>
      <DropdownToggle selectedItem={selectedItem} disabled={disabled} />
      <DropdownMenu
        items={filteredItems}
        onSelect={handleSelect}
        searchable={searchable}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
    </Dropdown>
  );
};

export default CustomDropdown;
